import { useNavigate, useParams, useLocation, useSearchParams } from 'react-router';
import i18n from '@/i18n';

export default function useSwitchLanguage() {
    const { lang } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = new useSearchParams();

    const switchLanguage = (newLang) => {
        if (lang === newLang) return;
        const newPathname = location.pathname.replace(/^\/[a-z]{2}/, `/${newLang}`);
        const search = searchParams.toString();
        const newUrl = `${newPathname}${search ? `?${search}` : ''}${location.hash || ''}`;
        i18n.changeLanguage(newLang);
        navigate(newUrl, { replace: true });
    };

    return { lang, switchLanguage };
}